export enum DialogType {
  // Default
  HIDDEN,

  // Storage
  AGREEMENT,
  QUIZ_ANSWER
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/enum/dialog-type.ts